export default "__VITE_ASSET__DNN8bdWO__"